module.exports = __webpack_public_path__ + "static/media/progress-modal-amended-option-bg.4bb44ed7.svg";